import script from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=29471e8a&lang=scss"

const __exports__ = script;

export default __exports__